import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: '[roof-type-7]',
    templateUrl: './roof-type-7.component.html',
    styleUrl: './roof-type-7.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class RoofType7Component {
}
